import { OrganizationManagerPagination, OrganizationManagerUser } from 'model/organizationManager';
import { Action } from 'redux';

export const ORGANIZATION_MANAGER_ERROR = 'organizationManager/error';
interface OrganizationManagerErrorAction extends Action<typeof ORGANIZATION_MANAGER_ERROR> {
    payload: {
        error: string;
    };
}

export const ORGANIZATION_MANAGER_CLEAR_ERROR = 'organizationManager/clear_error';
type OrganizationManagerClearErrorAction = Action<typeof ORGANIZATION_MANAGER_CLEAR_ERROR>;

export const ORGANIZATION_MANAGER_CLEAR_SUCCESS = 'organizationManager/clear_success';
type OrganizationManagerClearSuccessAction = Action<typeof ORGANIZATION_MANAGER_CLEAR_SUCCESS>;

export const ORGANIZATION_MANAGER_RESET = 'organizationManager/reset';
type OrganizationManagerResetAction = Action<typeof ORGANIZATION_MANAGER_RESET>;

export const ORGANIZATION_MANAGER_FETCH_START = 'organizationManager/fetch_start';
type OrganizationManagerFetchStartAction = Action<typeof ORGANIZATION_MANAGER_FETCH_START>;

export const ORGANIZATION_MANAGER_FETCH_SUCCESS = 'organizationManager/fetch_success';
interface OrganizationManagerFetchSuccessAction extends Action<typeof ORGANIZATION_MANAGER_FETCH_SUCCESS> {
    payload: {
        organizationManagers: Array<OrganizationManagerUser>;
        pagination?: OrganizationManagerPagination;
    };
}

export const ORGANIZATION_MANAGER_SAVE_START = 'organizationManager/save_start';
type OrganizationManagerSaveStartAction = Action<typeof ORGANIZATION_MANAGER_SAVE_START>;

export const ORGANIZATION_MANAGER_SAVE_SUCCESS = 'organizationManager/save_success';
interface OrganizationManagerSaveSuccessAction extends Action<typeof ORGANIZATION_MANAGER_SAVE_SUCCESS> {
    payload: {
        organizationManager: OrganizationManagerUser;
    };
}

export const ORGANIZATION_MANAGER_DELETE_START = 'organizationManager/delete_start';
type OrganizationManagerDeleteStartAction = Action<typeof ORGANIZATION_MANAGER_DELETE_START>;

export const ORGANIZATION_MANAGER_DELETE_SUCCESS = 'organizationManager/delete_success';
interface OrganizationManagerDeleteSuccessAction extends Action<typeof ORGANIZATION_MANAGER_DELETE_SUCCESS> {
    payload: {
        organizationManagerId: number;
    };
}

export type OrganizationManagerAction =
    | OrganizationManagerErrorAction
    | OrganizationManagerClearErrorAction
    | OrganizationManagerClearSuccessAction
    | OrganizationManagerResetAction
    | OrganizationManagerFetchStartAction
    | OrganizationManagerFetchSuccessAction
    | OrganizationManagerSaveStartAction
    | OrganizationManagerSaveSuccessAction
    | OrganizationManagerDeleteStartAction
    | OrganizationManagerDeleteSuccessAction;
